/* eslint-disable no-unused-vars */

'use strict';
var { default: Player } = require('@vimeo/player');
var EmblaCarousel = require('embla-carousel');
var slickConfigs = require('../config/slickConfigs');
var emblaUtil = require('../util/emblaCarousel');
var utils = require('pagedesigner/util/utils');
var debounce = require('lodash/debounce');
var cache = {};

/**
 * Resolve slick-based slide settings for suggestion Embla carousels.
 * @param {HTMLElement} rootNode - carousel root element
 * @returns {Object} slides config
 */
function getSuggestionEmblaSlidesConfig(rootNode) {
    var isTopPage = $(rootNode).closest('.pdp-top-page-carousel-wrapper').length > 0;
    var config = $.extend(true, {}, isTopPage ? slickConfigs.suggestionsTopPage : slickConfigs.suggestions);

    if ($('.page').data('action') === 'Cart-Show') {
        config.slidesToShow = 5;
    }

    return {
        slidesToShow: emblaUtil.getSlickOption(config, 'slidesToShow'),
        slidesToScroll: emblaUtil.getSlickOption(config, 'slidesToScroll') || 1
    };
}

/**
 * Init Embla on .product-suggestions-carousel.embla-slider elements
 * @param {jQuery} $wrapperEl - optional wrapper to scope the search
 */
function initSuggestionEmblaCarousels($wrapperEl) {
    var $wrapper = $wrapperEl || $(document);
    var carousels = $wrapper.find ? $wrapper.find('.product-suggestions-carousel.embla-slider') : $('.product-suggestions-carousel.embla-slider');

    carousels.each(function () {
        var rootNode = this;
        emblaUtil.initResponsiveEmblaCarousel(rootNode, EmblaCarousel, function () {
            return getSuggestionEmblaSlidesConfig(rootNode);
        });
    });
}

/**
 * PDP Video initialization and controlls based on carousel/grid state
 * @param {string} event - video state call
 */
function pdpVideoControl(event) {
    switch (event) {
        case 'init':
            if (typeof Player === 'undefined') {
                return;
            }
            cache.player = new Player('vimeo-player'); // eslint-disable-line no-undef
            break;

        case 'play':
        case 'unslick':
            cache.player.play();
            break;

        case 'pause':
            cache.player.pause();
            break;
        default:
            break;
    }
}

/**
 * Fix slick dots aria-labels to reflect correct slide count
 * @param {jQuery} $carousel - jQuery collection of carousel elements
 */
function fixSlickDotsAria($carousel) {
    $carousel.each(function () {
        var $dots = $(this).find('.slick-dots li button');
        var total = $dots.length;
        $dots.each(function (index) {
            $(this).attr('aria-label', (index + 1) + ' of ' + total);
        });
    });
}

/**
 * Init the PDP Carousel
 *
 */
function pdpCarouselInit() {
    var $pdpCarousel = $('.product-carousel:not(.embla)').not('.slick-initialized');
    var $playerSlide;

    if ($pdpCarousel.length) {
        $pdpCarousel
            .on('init', function () {
                $playerSlide = $('.video-slide');
                if ($playerSlide.length) {
                    pdpVideoControl('init');
                }
            })
            .on('unslick', function () {
                if ($('.video-slide').length) {
                    setTimeout(() => {
                        pdpVideoControl('unslick');
                    }, 1000);
                }
            })
            .on('afterChange', function () {
                if ($playerSlide.length) {
                    if ($playerSlide.parents('.slick-active').length) {
                        pdpVideoControl('play');
                    } else {
                        pdpVideoControl('pause');
                    }
                }
            })
            .slick(slickConfigs.pdp);

        fixSlickDotsAria($pdpCarousel.filter('.slick-initialized'));
    }
}

/**
 * Adjusting a carousel slidesToShow dynamically to prevent unwanted arrow/slide behaviors.
 * This is a specific case using 'variableWidth: true' on the carousel so it doesn't force slides width and allow the arrows to be visible only if needed
 * @param {*} className - carousel class
 */
function dynamicSlidesToShow(className) {
    var carousel = $(className).slick('getSlick');
    var slidesWidth = 322; // We know the slides have fixed width, so I'm simplyfing the calculations
    var carouselWidth = $(className).width();
    var updateSlidesToShow;
    var slidesCentered = false;

    if (carousel.options.slidesToShow > carousel.slideCount && ((slidesWidth * carousel.slideCount) - 12) <= carouselWidth) {
        updateSlidesToShow = carousel.slideCount;
        slidesCentered = true;
    } else {
        carousel.$slides.each(function (index) { // eslint-disable-line
            var count = index + 1;
            var isFullyVisible = (carousel.$slider[0].clientWidth >= this.offsetLeft + this.clientWidth);

            if (!isFullyVisible && index === carousel.options.slidesToShow) {
                return false;
            } else if (!isFullyVisible && index !== carousel.options.slidesToShow) {
                updateSlidesToShow = index;
                return false;
            } else if (isFullyVisible && count === carousel.$slides.length && carousel.options.slidesToShow < carousel.slideCount) {
                updateSlidesToShow = carousel.slideCount;
                slidesCentered = true;
            }
        });
    }

    if (updateSlidesToShow > 0) {
        $(className).toggleClass('slides-centered', slidesCentered).slick('slickSetOption', {
            slidesToShow: updateSlidesToShow,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: updateSlidesToShow
                    }
                }
            ]
        }, true);
    }
}

/**
 * Sync PLP tile image carousel DOM for accessibility (tab panels, focus, live status, desktop stacked view).
 * @param {HTMLElement} track - .tile-image-carousel
 * @param {NodeListOf<Element>} slides - .slide elements
 * @param {NodeListOf<Element>} dots - .tile-carousel__dot buttons
 * @param {HTMLElement|null} statusEl - .tile-carousel__status
 * @param {number} activeIdx - active slide index
 * @param {{ lastSpokenIdx: number }} announceState - mutable ref for polite announcements
 * @param {Object} [options] - Optional flags for announcements.
 * @param {boolean} [options.silent] - Suppress live region updates (e.g. hover).
 * @param {boolean} [options.isInit] - Suppress live region updates on first paint.
 */
function updateTileImageCarouselA11y(track, slides, dots, statusEl, activeIdx, announceState, options) {
    var i;
    var silent = options && options.silent;
    var isInit = options && options.isInit;
    var isScrollable = track.scrollWidth > track.clientWidth + 2;

    for (i = 0; i < slides.length; i++) {
        var slide = slides[i];
        var isActive = i === activeIdx;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        var focusables = slide.querySelectorAll('a, button');
        for (var k = 0; k < focusables.length; k++) {
            var focusable = focusables[k];
            if (isActive) {
                focusable.removeAttribute('tabindex');
            } else {
                focusable.setAttribute('tabindex', '-1');
            }
        }
    }

    for (i = 0; i < dots.length; i++) {
        var d = dots[i];
        var dotActive = i === activeIdx;
        d.classList.toggle('is-active', dotActive);
        d.setAttribute('aria-selected', dotActive ? 'true' : 'false');
    }

    if (!isScrollable) {
        track.classList.toggle('tile-carousel--show-second', activeIdx === 1);
    } else {
        track.classList.remove('tile-carousel--show-second');
    }

    if (statusEl && !silent && !isInit && announceState.lastSpokenIdx !== activeIdx) {
        announceState.lastSpokenIdx = activeIdx;
        var msg = statusEl.getAttribute('data-carousel-status-' + activeIdx);
        if (msg) {
            statusEl.textContent = msg;
        }
    }
}

/**
 * Init the PLP tiles carousels
 */
function tileImageCarouselInit() {
    document.querySelectorAll('.image-container.has-carousel').forEach(function (root) {
        if (root.getAttribute('data-tile-carousel-init') === '1') {
            return;
        }
        root.setAttribute('data-tile-carousel-init', '1');

        var track = root.querySelector('.tile-image-carousel');
        var slides = root.querySelectorAll('.slide');
        var dots = root.querySelectorAll('.tile-carousel__dot');
        var statusEl = root.querySelector('.tile-carousel__status');
        var tablist = root.querySelector('.tile-carousel__dots[role="tablist"]');
        var announceState = { lastSpokenIdx: -1 };

        if (!track || !slides.length) return;

        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        /**
         * Desktop stacked / hover carousel for PLP tiles. Threshold must stay aligned with
         * `_productTiles.scss` on `.tile-image-carousel` / dots: this codebase uses `media-breakpoint-up(md)` = 992px (not Bootstrap default 768px).
         * @returns {boolean} True if desktop stacked layout, false otherwise.
         */
        function isDesktopStackedLayout() {
            return track.scrollWidth <= track.clientWidth + 2 && window.matchMedia('(min-width: 992px)').matches;
        }

        /**
         * Go to slide
         * @param {number} idx - slide index
         * @returns {void}
         */
        function goToSlide(idx) {
            if (idx < 0 || idx >= slides.length) return;
            var target = slides[idx];
            if (track.scrollWidth > track.clientWidth + 2 && target) {
                target.scrollIntoView({
                    behavior: prefersReducedMotion ? 'auto' : 'smooth',
                    block: 'nearest',
                    inline: 'start'
                });
            }
            updateTileImageCarouselA11y(track, slides, dots, statusEl, idx, announceState, {});
        }

        /**
         * Get active index from DOM
         * @returns {number} Active slide index.
         */
        function getActiveIndexFromDom() {
            var j;
            for (j = 0; j < slides.length; j++) {
                if (slides[j].getAttribute('aria-hidden') === 'false') {
                    return j;
                }
            }
            return 0;
        }

        dots.forEach(function (dot, idx) {
            dot.addEventListener('click', function () {
                goToSlide(idx);
            });
        });

        if (track.scrollWidth > track.clientWidth + 2) {
            var io = new IntersectionObserver(function (entries) {
                var bestRatio = 0;
                var bestIdx = -1;
                entries.forEach(function (entry) {
                    if (entry.intersectionRatio > bestRatio) {
                        bestRatio = entry.intersectionRatio;
                        bestIdx = Array.prototype.indexOf.call(slides, entry.target);
                    }
                });
                if (bestRatio >= 0.51 && bestIdx >= 0) {
                    updateTileImageCarouselA11y(track, slides, dots, statusEl, bestIdx, announceState, {});
                }
            }, { root: track, threshold: [0.25, 0.5, 0.51, 0.6, 0.75, 1] });

            slides.forEach(function (s) {
                io.observe(s);
            });
        }

        track.addEventListener('pointerenter', function () {
            if (isDesktopStackedLayout()) {
                updateTileImageCarouselA11y(track, slides, dots, statusEl, 1, announceState, { silent: true });
            }
        });
        track.addEventListener('pointerleave', function () {
            if (isDesktopStackedLayout()) {
                updateTileImageCarouselA11y(track, slides, dots, statusEl, 0, announceState, { silent: true });
            }
        });

        root.addEventListener('keydown', function (e) {
            if (slides.length < 2) return;
            var t = e.target;
            if (!root.contains(t) || (t.closest && t.closest('.quickview'))) return;
            if (t.classList && t.classList.contains('tile-carousel__dot')) return;
            var current = getActiveIndexFromDom();
            var next = current;
            if (e.key === 'ArrowRight') {
                next = Math.min(slides.length - 1, current + 1);
            } else if (e.key === 'ArrowLeft') {
                next = Math.max(0, current - 1);
            } else if (e.key === 'Home') {
                next = 0;
            } else if (e.key === 'End') {
                next = slides.length - 1;
            } else {
                return;
            }
            e.preventDefault();
            goToSlide(next);
        }, true);

        if (tablist && dots.length) {
            tablist.addEventListener('keydown', function (e) {
                var tabs = Array.prototype.slice.call(dots);
                var focused = document.activeElement;
                var idx = tabs.indexOf(focused);
                if (idx < 0) return;
                if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                    e.preventDefault();
                    var nextTab = Math.min(tabs.length - 1, idx + 1);
                    goToSlide(nextTab);
                    tabs[nextTab].focus();
                } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                    e.preventDefault();
                    var prevTab = Math.max(0, idx - 1);
                    goToSlide(prevTab);
                    tabs[prevTab].focus();
                } else if (e.key === 'Home') {
                    e.preventDefault();
                    goToSlide(0);
                    tabs[0].focus();
                } else if (e.key === 'End') {
                    e.preventDefault();
                    goToSlide(tabs.length - 1);
                    tabs[tabs.length - 1].focus();
                }
            });
        }

        updateTileImageCarouselA11y(track, slides, dots, statusEl, 0, announceState, { isInit: true });
        announceState.lastSpokenIdx = 0;
    });
}

/**
 * Mobile Drawer Carousels
 */
function mobileDrawerCarousel() {
    if ($('.cart-promo-drawer').length > 0 && $('#drawerContent').hasClass('show')) {
        $('.drawer-toggler').click();
    }
    if ($('.drawer-carousel').hasClass('slick-initialized')) {
        $('.drawer-carousel').slick('unslick');
    }
}

/**
 * Desktop Drawer Carousels
 */
function desktopDrawerCarousel() {
    $('.drawer-carousel').not('.slick-initialized').slick(slickConfigs.promoDrawerCarousel);
}

/**
 * Global Banner Carousel Mobile :: Page Designer COmponent
 */
function mobileCarouselGlobalBanner() {
    $('.global-banner-items-wrapper.has-carousel').each(function () {
        if (utils.mediaBreakpointDown('sm')) {
            var carouselAutoplay = $(this).data('carousel-autoplay');
            var carouselSpeed = $(this).data('carousel-speed');
            var carouselAnimationSpeed = $(this).data('carousel-animationspeed');

            $(this).not('.slick-initialized').slick({
                autoplay: carouselAutoplay,
                autoplaySpeed: carouselSpeed,
                infinite: true,
                speed: carouselAnimationSpeed,
                slidesToShow: 1,
                prevArrow: "<button class='slick-prev slick-arrow' type='button' aria-label='Previous'><span class='sr-only'>Previous</span></button>",
                nextArrow: "<button class='slick-next slick-arrow' type='button' aria-label='Next'><span class='sr-only'>Next</span></button>"
            });

            var $carousel = $(this);
            var updateClonedAria = function () {
                $carousel.find('.slick-cloned').attr('aria-hidden', 'true');
                $carousel.find('.slick-slide:not(.slick-cloned).slick-active').attr('aria-hidden', 'false');
            };
            updateClonedAria();
            $carousel.on('afterChange', updateClonedAria);
        } else if (!utils.mediaBreakpointDown('sm')) {
            if ($(this).hasClass('slick-initialized')) {
                $(this).slick('unslick');
            }
        }
    });
}

var toggleDrawerCarouselBool;

/**
 * Toggle Drawer Carousels
 */
function toggleDrawerCarousel() {
    if (utils.mediaBreakpointDown('sm')) {
        if (!toggleDrawerCarouselBool) {
            mobileDrawerCarousel();
            mobileCarouselGlobalBanner();
            toggleDrawerCarouselBool = true;
        }
    } else if (!utils.mediaBreakpointDown('sm')) {
        if (toggleDrawerCarouselBool || toggleDrawerCarouselBool === undefined) {
            desktopDrawerCarousel();
            mobileCarouselGlobalBanner();
            toggleDrawerCarouselBool = false;
        }
    }
}

/**
 * Destroy slick/embla instances inside recommended alternatives carousel
 * @param {jQuery} $wrapper - carousel container or wrapper element
 */
function destroyRecommendedAlternativesCarousel($wrapper) {
    if (!$wrapper || !$wrapper.length) {
        return;
    }

    $wrapper.find('.product-suggestions-carousel').each(function () {
        var $carousel = $(this);
        var rootNode = this;

        if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
        }

        if (rootNode.emblaApiRef) {
            rootNode.emblaApiRef.destroy();
            rootNode.emblaApiRef = null;
        }

        $carousel.removeClass('embla-initialized');
    });
}

/**
 * Init Embla on recommended alternatives carousel tiles
 * @param {jQuery} $wrapperEl - wrapper element
 */
function initRecommendedAlternativesEmbla($wrapperEl) {
    var $wrapper = $wrapperEl || $(document);
    var carousels = $wrapper.find('.recommended-alternatives-carousel.embla-slider:not(.embla-initialized)');

    carousels.each(function () {
        var rootNode = this;
        var viewportNode = rootNode.querySelector('.embla__viewport');
        if (!viewportNode) {
            return;
        }

        var slideCount = rootNode.querySelectorAll('.embla-slide').length;
        if (slideCount <= 1) {
            return;
        }

        var isMobile = window.innerWidth < 992;
        var visibleSlides = isMobile ? 2 : 3;
        if (slideCount <= visibleSlides) {
            return;
        }

        try {
            var emblaApi = EmblaCarousel(viewportNode, { // eslint-disable-line new-cap
                loop: true,
                align: 'start',
                slidesToScroll: 1
            });

            emblaUtil.setupEmblaNavigation(emblaApi, rootNode);
            emblaUtil.setupEmblaPagination(emblaApi, rootNode);
            emblaUtil.updateSlideAriaVisibility(emblaApi, rootNode);
            emblaApi.on('select', function () { emblaUtil.updateSlideAriaVisibility(emblaApi, rootNode); });
            emblaApi.on('reInit', function () { emblaUtil.updateSlideAriaVisibility(emblaApi, rootNode); });

            rootNode.classList.add('embla-initialized');
            rootNode.emblaApiRef = emblaApi;
        } catch (e) {
            console.error('Recommended alternatives Embla initialization failed:', e);
        }
    });
}

/**
 * Init globally reusable carousels
 */
module.exports = {
    heroCarousels: function () {
        var $hero = $('.hero-caro');
        $hero.slick(slickConfigs.hero);
        fixSlickDotsAria($hero.filter('.slick-initialized'));
    },

    globalBannerCarousel: function () {
        mobileCarouselGlobalBanner();

        utils.smartResize(function () {
            toggleDrawerCarousel();
        });
    },

    promoDrawerCarousel: function () {
        toggleDrawerCarousel();

        utils.smartResize(function () {
            toggleDrawerCarousel();
        });
    },

    pdpCarousel: function () {
        pdpCarouselInit();

        $(window).on('resize', debounce(function () {
            if (utils.mediaBreakpointDown('lg')) {
                $('.product-carousel:not(.embla)').not('.slick-initialized').slick(slickConfigs.pdp);
            }
        }, 500));
    },

    addedModalProductsCarousel: function ($wrapperEl) {
        if ($wrapperEl) {
            let $wrapper = $wrapperEl || $(document);
            let $carousel = $('.added-modal-products-carousel:not(.embla-slider):not(.slick-initialized):not(.recommends-widget)', $wrapper);

            $carousel.each(function () {
                let $this = $(this);
                if ($this.find('div.product').length > 1) {
                    $this.slick(slickConfigs.addedModal);
                }
            });
            fixSlickDotsAria($carousel.filter('.slick-initialized'));
        }
    },

    einsteinSupportedCarousels: function ($wrapperEl) {
        let $wrapper = $wrapperEl || $(document);
        let $carousel;
        let config;

        /*
        * Show 'pdp-product-recommendations-top-page' on entry page only
        */
        if ($wrapper.hasClass('pdp-top-page-carousel-wrapper') && window.location.href.toLowerCase().indexOf('refcode') < 0) {
            $wrapper.find('[id^="cq_recomm_slot"]').empty();
        }

        if ($wrapper.find('.product-suggestions-carousel').length > 0) {
            $carousel = $wrapper.find('.product-suggestions-carousel');
            config = $wrapper.hasClass('pdp-top-page-carousel-wrapper') ? slickConfigs.suggestionsTopPage : slickConfigs.suggestions;

            if ($('.page').data('action') === 'Cart-Show') {
                config.slidesToShow = 5;
            }
        } else if ($wrapper.find('.product-carousel-standard').length > 0) {
            $carousel = $wrapper.find('.product-carousel-standard');
            config = slickConfigs.standard;

            if ($carousel.data('slides')) {
                config.slidesToShow = $carousel.data('slides');
            }
        } else if ($wrapper.find('.home-einstein-carousel').length > 0) {
            $carousel = $wrapper.find('.home-einstein-carousel');
            config = slickConfigs.suggestions;

            var $module = $wrapper.closest('.experience-component');
            var autoPlayInput = $module.find('.carousel-autoplay');
            var hasAutoplay = autoPlayInput.length > 0;
            if (hasAutoplay) {
                config = $.extend(true, { autoplay: true, autoplaySpeed: autoPlayInput.val() }, config);
            }
        }

        if ($carousel) {
            if ($carousel.hasClass('embla-slider')) {
                initSuggestionEmblaCarousels($wrapper);
            } else if ($carousel.find('div.product').length > 1) {
                $carousel.not('.slick-initialized').slick(config);
            }
        }
    },

    tileImageCarousel: function () {
        tileImageCarouselInit();
        $(document.body).on('tileImageCarousel:init', tileImageCarouselInit);
    },

    einsteinCarouselsObserver: function () {
        $('.js-einstein-carousel-supported').each(function () {
            var $this = $(this);
            /*
            * Observer will only be created if the slot is configured to use Einstein. If not, the slider will be initialized by the normal init function
            * Slots that currently suppport Einstein recommender:
            * - home-einstein-carousel
            * - pdp-product-recommendations-top-page
            * - pdp-product-recommendations-1
            * - pdp-product-recommendations-2
            * - pdp-recently-viewed
            * - cart-recommendations-m
            */
            if ($this.find('[id^="cq_recomm_slot"]').length > 0 && $this.find('.slick-initialized').length === 0) {
                utils.mutationObserver($this, function () { module.exports.einsteinSupportedCarousels($this); });
            }
        });
    },

    bloomreachCarousel: function () {
        $('.br-carousel-supported').each(function () {
            var $this = $(this);
            if ($this.find('.product').length > 0 && $this.find('.slick-initialized').length === 0) {
                module.exports.einsteinSupportedCarousels($this);
            }
        });
    },

    destroyRecommendedAlternativesCarousel: destroyRecommendedAlternativesCarousel,

    recommendedAlternativesCarousel: function ($wrapperEl) {
        var $scope = $wrapperEl || $(document);
        var $wrappers = $scope.hasClass('recommended-alternatives-carousel-wrapper')
            ? $scope
            : $scope.find('.recommended-alternatives-carousel-wrapper');

        if (!$wrappers.length && $scope.is('#recommended-alternatives-carousel-container')) {
            $wrappers = $scope.find('.recommended-alternatives-carousel-wrapper');
        }

        $wrappers.each(function () {
            var $wrapper = $(this);
            var $carousel = $wrapper.find('.product-suggestions-carousel.recommended-alternatives-carousel');

            if (!$carousel.length) {
                return;
            }

            if ($carousel.hasClass('embla-slider')) {
                initRecommendedAlternativesEmbla($wrapper);
            } else if ($carousel.find('.recommended-alternative-tile').length > 1) {
                $carousel.not('.slick-initialized').slick(slickConfigs.recommendedAlternatives);
                fixSlickDotsAria($carousel.filter('.slick-initialized'));
            }
        });
    }
};
